exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar .orgChangeDialog .el-dialog__body{padding:10px 20px}.navbar .el-dialog__body{width:100%;height:500px}.navbar .el-dropdown:hover{width:100%;cursor:pointer;color:#2773ff}\n", ""]);

// exports
